// extracted by mini-css-extract-plugin
module.exports = {"wrapperToggle":"Toggle-module-wrapperToggle--wQOrm","checkbox":"Toggle-module-checkbox--B5jsT","checkboxView":"Toggle-module-checkboxView--boyDx"};